import SBRebuy from "./sb-rebuy.js";
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.modal = this.closest(".search-modal");
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.closest(".search-input").querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.searchTerm = "";
    this.searchApiType = this.dataset.searchApiType || "shopify";

    this.setupEventListeners();
    this.activeDepartment();
  }

  setupEventListeners() {
    this.querySelector("form.search").addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
    this.input.addEventListener("focus", this.onFocus.bind(this));

    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
    this.closest(".sb_header")
      .querySelector('.search__recommendation button[type="reset"]')
      ?.addEventListener("click", this.close.bind(this));
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener("click", this.onBodyClickEvent);

    this.closest(".sb_header")
      ?.querySelector('.predictive-search button[type="reset"]')
      ?.addEventListener("click", this.clear.bind(this));

    this.closest(".sb_header")?.querySelector(".search__close")?.addEventListener("click", this.mobileClose.bind(this));

    document.querySelector(".search-mobile-drawer")?.addEventListener("click", this.mobileOpen.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.openRecommendation();
      return;
    }

    if (this.searchApiType === "rebuy") {
      this.getRebuySearchResults(this.searchTerm);
    } else if (this.searchApiType === "shopify") {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFormSubmit(event) {
    const brandRedirects = this.querySelector("#brand-redirects")?.textContent;
    const brandRedirectsJson = JSON.parse(brandRedirects);
    const brandRedirect = brandRedirectsJson.find((redirect) =>
      redirect.phrases.find((phrase) => phrase.toLowerCase().trim() === this.getQuery().toLowerCase().trim()),
    );
    if (brandRedirect) {
      window.location.href = brandRedirect.destination;
      event.preventDefault();
    } else {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
        event.preventDefault();
      }
    }
  }

  openRecommendation() {
    this.querySelector(".search__recommendation").classList.add("open");
    this.closest(".search-modal")?.classList.add("recommendation-open");
    document.body.classList.add("search-modal--open");
    document.querySelector("sb-search-recommendation")?.renderRecentSearchTerms();
  }

  closeRecommendation() {
    this.querySelector(".search__recommendation").classList.remove("open");
    this.closest(".search-modal")?.classList.remove("recommendation-open");
  }

  onFocus() {
    document.body.classList.add("predictive-search--focus");
    const currentSearchTerm = this.getQuery();
    this.openRecommendation();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      if (this.searchApiType === "rebuy") {
        this.getRebuySearchResults(this.searchTerm);
      } else if (this.searchApiType === "shopify") {
        this.getSearchResults(this.searchTerm);
      }
    }
  }

  onFocusOut() {
    // setTimeout(() => {
    //   if (!this.contains(document.activeElement)) this.close();
    // });
  }

  onKeyup(event) {
    if (!this.getQuery().length) {
      // this.clear(event);
      // this.close(true);
      if (this.closest(".search-modal")?.classList.contains("searching")) {
        this.openRecommendation();
        this.closest(".search-modal").classList.remove("searching");
      }
    }
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");

    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      /*
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      */
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll("li");
    let activeElement = this.querySelector("li");

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  pushRecentSearchTerm(searchTerm) {
    let recentSearchTerms = JSON.parse(localStorage.getItem("recentSearchTerms")) || [];
    recentSearchTerms.unshift(searchTerm);
    recentSearchTerms = [...new Set(recentSearchTerms)];
    recentSearchTerms = recentSearchTerms.slice(0, 5);
    localStorage.setItem("recentSearchTerms", JSON.stringify(recentSearchTerms));
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const perPage = this.dataset.perPage || 4;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      if (this.modal) this.modal.classList.add("searching");
      this.closeRecommendation();
      return;
    }

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent(
        "resources[limit]",
      )}=${perPage}&${encodeURIComponent("resources[limit_scope]")}=each&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        /*
        this.cachedResults[queryKey] = resultsMarkup;
        */
        this.renderSearchResults(resultsMarkup);

        if (this.modal) this.modal.classList.add("searching");
        this.closeRecommendation();
        this.pushRecentSearchTerm(searchTerm);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }

        this.close();
        throw error;
      });
  }

  getRebuySearchResults(searchTerm) {
    const apiUrl = "https://rebuyengine.com/api/v1/smart-search/search/quick-view";
    const apiKey = theme.rebuy.key;
    const excludedProducts = theme.rebuyExcludedProducts?.split(",") || [];
    if (!apiKey) return;
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const perPage = this.dataset.perPage || 4;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      if (this.modal) this.modal.classList.add("searching");
      this.closeRecommendation();
      return;
    }

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Rebuy-Api-Key": apiKey,
      },
      body: JSON.stringify({
        query: searchTerm,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((data) => {
        const excludedProducts = theme.rebuyExcludedProducts?.split(",") || [];
        const productSuggestions =
          data?.data?.productSuggestions?.filter((product) => !excludedProducts.includes(product.id)) || [];
        const collections = data?.data?.collections || [];
        this.renderRebuySearchResults(collections, productSuggestions);
        if (this.modal) this.modal.classList.add("searching");
        this.closeRecommendation();
        this.pushRecentSearchTerm(searchTerm);
        document.querySelector("#predictive-search-option-search-keywords a").href = `/search?q=${encodeURIComponent(
          searchTerm,
        )}`;
        document.querySelector(".predictive-search-results.is-empty .search-term").textContent = searchTerm;
        this.pushGtagSearchTerm(data);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }

        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.closest(".search-input").querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  pushGtagSearchTerm(data) {
    const productSuggestionsCount = data?.data?.productSuggestions?.length;
    if (window.gtag && this.getQuery() && productSuggestionsCount > 0) {
      window.gtag("event", "view_search_results", {
        search_term: this.getQuery(),
      });
    } else if (window.gtag && this.getQuery() && productSuggestionsCount === 0) {
      window.gtag("event", "no_search_results", {
        search_term: this.getQuery(),
      });
    }
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.open();

    this.closest(".sb_header")
      .querySelector('.predictive-search button[type="reset"]')
      ?.addEventListener("click", this.clear.bind(this));
  }

  renderRebuySearchResults(collections, productSuggestions) {
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
    const notEmpty = document.querySelector(".predictive-search-results.not-empty-results");
    const isEmpty = document.querySelector(".predictive-search-results.is-empty");
    if (collections.length == 0 && productSuggestions.length == 0) {
      notEmpty.classList.add("hidden");
      isEmpty.classList.remove("hidden");
      return;
    } else {
      notEmpty.classList.remove("hidden");
      isEmpty.classList.add("hidden");
    }
    this.rebuyCollectionsMarkup(collections);
    this.rebuyProductSuggestionsMarkup(productSuggestions);
  }

  rebuyCollectionsMarkup(collections) {
    collections = collections.sort((a, b) => a.name.localeCompare(b.name));
    const collectionsElm = this.closest(".sb_header").querySelector(".suggestions-collections-list");
    const dummyCollectionsElm = this.closest(".sb_header").querySelector(".dummy-collections");
    const dummyCollectionItem = dummyCollectionsElm.querySelector("li").cloneNode(true);
    const brandsElm = this.closest(".sb_header").querySelector(".suggestions-brands-list");
    const dummyBrandsElm = this.closest(".sb_header").querySelector(".dummy-brands");
    const dummyBrandItem = dummyBrandsElm.querySelector("li").cloneNode(true);
    const allBrands = theme.allBrands.split(",");
    collectionsElm.innerHTML = "";
    brandsElm.innerHTML = "";
    if (collections.length === 0) {
      collectionsElm.closest(".suggestions-results-wrapper").classList.add("hidden");
      brandsElm.closest(".suggestions-results-wrapper").classList.add("hidden");
      return;
    } else {
      collectionsElm.closest(".suggestions-results-wrapper").classList.remove("hidden");
    }
    dummyCollectionsElm.classList.add("hidden");
    collections.forEach((collection) => {
      if (allBrands.includes(collection.name.toLowerCase())) {
        const brandItem = dummyBrandItem.cloneNode(true);
        brandItem.querySelector("a").href = `/collections/${collection.handle}`;
        brandItem.querySelector(".predictive-search__item-heading").textContent = collection.name.toLowerCase();
        brandsElm.appendChild(brandItem);
      } else {
        const collectionItem = dummyCollectionItem.cloneNode(true);
        collectionItem.querySelector("a").href = `/collections/${collection.handle}`;
        collectionItem.querySelector(".predictive-search__item-heading").textContent = collection.name.toLowerCase();
        collectionsElm.appendChild(collectionItem);
      }
    });
  }

  rebuyProductSuggestionsMarkup(productSuggestions) {
    const productElm = document.querySelector("#predictive-search-results-products-list");
    productElm.innerHTML = "";
    productSuggestions.forEach((item) => {
      fetch(`${window.origin}/products/${item.handle}?section_id=sb-rebuy-quick-search-card`)
        .then((response) => response.text())
        .then((data) => {
          const productDom = new DOMParser().parseFromString(data, "text/html");
          if (productDom) {
            productElm.appendChild(productDom.querySelector(".predictive-search__list-item li"));
          }
        })
        .catch((error) => {
          console.error("Error rendering product DOM:", error);
        });
    });
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.closest(".search-input").querySelector("[data-predictive-search-live-region-count-value]").textContent,
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom;
    // if (this.resultsMaxHeight > 526) {
    //   return 580;
    // }
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.height = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    document.body.classList.add("predictive-search--focus");
    document.body.classList.add("search-modal--open");
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    this.closeRecommendation();
    this.input.blur();
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    document.body.classList.remove("predictive-search--focus");
    document.body.classList.remove("search-modal--open");
  }

  clear(event) {
    // event.preventDefault();

    this.input.value = "";
    this.removeAttribute("open");
    this.removeAttribute("results");
    this.input.focus();
    this.close(true);

    if (this.modal) this.modal.classList.remove("searching");
  }

  onBodyClick(event) {
    const target = event.target;
    if (!document.body.classList.contains("predictive-search--focus")) {
      return;
    }
    if (
      this.contains(target) ||
      target.closest(".search__recommendation") ||
      target.closest(".predictive-search.predictive-search--header") ||
      target.closest(".icon-close")
    ) {
      return;
    }

    this.clear(event);
    this.close(true);
  }

  mobileOpen() {
    const searchField = this.closest("search-field");
    searchField.classList.add("open");
    this.openRecommendation();
    document.body.classList.add("search-modal--open");
  }

  mobileClose() {
    this.clear();
    const searchField = this.closest("search-field");
    searchField.classList.remove("open");
    this.closeRecommendation();
    document.body.classList.remove("search-modal--open");
  }

  activeDepartment() {
    const activeDepartment = document.querySelector(".sb-header__department.active");
    if (activeDepartment) {
      const departmentName = activeDepartment
        .querySelector(".sb-header__department-inner")
        .getAttribute("data-department-name");
      if (departmentName) {
        theme.activeDepartment = departmentName;
      }
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);

class SBSearchRecommendation extends HTMLElement {
  constructor() {
    super();
    const currentDepartmentEndpointId =
      document.querySelector(".sb-header__department.active .sb-header__department-inner")?.dataset
        ?.rebuyCustomEndpointId || null;

    if (currentDepartmentEndpointId) {
      this.rebuyProductType = "custom_endpoint";
      this.rebuyCustomEndpointId = currentDepartmentEndpointId;
    } else {
      this.rebuyProductType = this.dataset.rebuyProductType;
      this.rebuyCustomEndpointId = false;
    }
    this.rebuyEnabled = this.dataset.rebuyEnabled === "true" || false;
    this.productLimit = parseInt(this.dataset.productLimit);
    this.rebuyDynamicProduct =
      this.dataset.rebuyDynamicProduct === "false" ? false : parseInt(this.dataset.rebuyDynamicProduct);
    this.customerId = this.dataset.customerId === "false" ? false : parseInt(this.dataset.customerId);
  }

  connectedCallback() {
    if (this.rebuyEnabled) {
      this.fetchRebuyProducts();
    }
    this.renderRecentSearchTerms();
  }

  getBrandRedirectDestination(searchTerm) {
    const brandRedirectsText = document.querySelector("predictive-search #brand-redirects")?.textContent;

    if (!brandRedirectsText || !searchTerm) return null;

    try {
      const parsedRedirects = JSON.parse(brandRedirectsText);
      const brandRedirects = Array.isArray(parsedRedirects) ? parsedRedirects : [parsedRedirects];
      const normalizedSearchTerm = searchTerm.toLowerCase().trim();

      const matchedRedirect = brandRedirects.find(
        (redirect) =>
          redirect?.destination &&
          Array.isArray(redirect?.phrases) &&
          redirect.phrases.some(
            (phrase) => typeof phrase === "string" && phrase.toLowerCase().trim() === normalizedSearchTerm,
          ),
      );

      return matchedRedirect?.destination || null;
    } catch (error) {
      return null;
    }
  }

  getRecentSearchHref(searchTerm) {
    return (
      this.getBrandRedirectDestination(searchTerm) ||
      `${window.location.origin}/search?q=${encodeURIComponent(searchTerm)}&type=${theme.searchResults}`
    );
  }

  async fetchRebuyProducts() {
    const rebuyInstance = new SBRebuy();
    rebuyInstance.initRebuyVariables(
      this.rebuyProductType,
      this.productLimit,
      this.rebuyDynamicProduct,
      this.customerId,
      this.rebuyCustomEndpointId,
    );
    const products_handle = await rebuyInstance.fetchRebuyProducts();
    this.renderProducts(products_handle);
  }

  renderProducts(products_handle) {
    let completed = 0;
    const total = products_handle.length;
    products_handle.forEach((handle) => {
      this.renderProductDom(handle, () => {
        completed++;
        if (completed === total) {
          const loadingBar = this.closest(".search__recommendation").querySelector(".loading-bar");
          if (loadingBar) {
            loadingBar.classList.add("hidden");
          }
          this.classList.add("loaded-products");
        }
      });
    });
  }

  renderProductDom(handle, callback) {
    fetch(`${window.origin}/products/${handle}?section_id=sb-rebuy-product`)
      .then((response) => response.text())
      .then((data) => {
        const productDom = new DOMParser().parseFromString(data, "text/html");
        if (productDom) {
          const cardWrapper = productDom.querySelector(".sb-featured-products__card-wrapper");
          if (cardWrapper) {
            const rebuyEndpointId =
              this.rebuyProductType === "custom_endpoint" && this.rebuyCustomEndpointId
                ? this.rebuyCustomEndpointId
                : this.rebuyProductType;

            const productLinks = cardWrapper.querySelectorAll("a");
            productLinks.forEach((link) => {
              const url = new URL(link.href, window.location.origin);
              url.searchParams.delete("utm_campaign");
              url.searchParams.set("utm_campaign", `carousel_${rebuyEndpointId}`);
              link.href = url.toString();
            });

            this.appendChild(cardWrapper);
          }
        }
        callback();
      })
      .catch((error) => {
        console.error("Error rendering product DOM:", error);
        callback();
      });
  }

  renderRecentSearchTerms() {
    const recentSearchTerms = JSON.parse(localStorage.getItem("recentSearchTerms")) || [];
    const recentSearchTermsContainer = this.closest(".search__recommendation");
    const recentSearchTermsList = recentSearchTermsContainer.querySelector(".recent-searches-list");

    recentSearchTermsList.innerHTML = "";
    if (recentSearchTerms.length === 0) {
      recentSearchTermsContainer.querySelector(".recent-searches").classList.add("hidden");
      return;
    }
    recentSearchTermsContainer.querySelector(".recent-searches").classList.remove("hidden");

    recentSearchTerms.forEach((term) => {
      const recentSearchHref = this.getRecentSearchHref(term);
      recentSearchTermsList.innerHTML += `
      <li>
       <a href="${recentSearchHref}">
        <div class="search-item">
            <span class="icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8C14 4.6875 11.3125 2 8 2Z" stroke="#858A91" stroke-width="0.8" stroke-miterlimit="10"></path>
                <path d="M8 4V8.5H11" stroke="#858A91" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
            <span class="search-text">${term}</span>
            </div>
          </a>
        <span class="icon-close" onclick="document.querySelector('sb-search-recommendation').removeRecentSearchTerm('${term}')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33334 3.55823L12.6667 12.8916M3.33334 12.8916L12.6667 3.55823" stroke="#1A1E24" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
      </li>`;
    });
  }

  removeRecentSearchTerm(term) {
    let recentSearchTerms = JSON.parse(localStorage.getItem("recentSearchTerms")) || [];
    recentSearchTerms = recentSearchTerms.filter((t) => t !== term);
    localStorage.setItem("recentSearchTerms", JSON.stringify(recentSearchTerms));
    this.renderRecentSearchTerms();
  }

  clearRecentSearchTerms() {
    localStorage.removeItem("recentSearchTerms");
    this.renderRecentSearchTerms();
  }
}

customElements.define("sb-search-recommendation", SBSearchRecommendation);
